import React from 'react';
import styles from '../../styles/match-event-placeholders.module.scss'
import classNames from "classnames";

export const MatchEventModulePlaceholderEvent = ({invert}) => {
  return (
    <div className={classNames(styles.event, {[styles.invert]: invert})}>
      <div className={classNames(styles.team)}>
        <div className={classNames(styles.round)}/>
        <div className={classNames(styles.label)}/>
      </div>
      <div className={classNames(styles.icon)}/>
    </div>
  )
};
